module.exports = __webpack_public_path__ + "img/07.359664a8.png";